// eslint-disable-next-line no-shadow
export enum HomeScreens {
  YourSchedule = 'YourSchedule',
  AboutShift = 'AboutShift',
  Lockout = 'Lockout',
  OpenShifts = 'OpenShifts',
  Driver = 'Driver',
  PastRuns = 'PastRuns',
  PastOrders = 'PastOrders',
  Shopper = 'Shopper',
  Tutorials = 'Tutorials',
  MemoDetails = 'MemoDetails',
  AttachmentsPage = 'AttachmentsPage',
  UPCShifts = 'UPCShifts',
  Tip = 'Tip',
  B2B = 'B2B',
  DriverOrders = 'DriverOrders',
  Components = 'components',
}

// eslint-disable-next-line no-shadow
export enum ShopperScreens {
  BatchDetailsPage = 'BatchDetailsPage',
  ItemDetails = 'ItemDetails',
  AddItemPage = 'AddItemPage',
  OrderPackingPage = 'OrderPackingPage',
  PdfDetailScreen = 'PdfDetailScreen',
  UPCShifts = 'UPCShifts',
  VanLoadSite = 'VanLoadSite',
  ScannedAddItemPage = 'ScannedAddItemPage',
}
